export default __webpack_public_path__ + "static/medication-e575b3a87353ea8626893da28f257eea.svg";